import { IDepartmentOption } from "./IExternalAgent";

interface IProps {
    departments: Array<IDepartmentOption>;
    agentDepartments: Array<number>;
    onChange: (updatedDepartments: Array<number>) => void;
}

/**
 * Which departments' work this agent can take. They travel to TaskRouter as `categories`.
 */
const Departments = ({ departments, agentDepartments, onChange }: IProps) => {
    return (
        <>
            Departments
            <hr />
            {departments.map((department: IDepartmentOption) => (
                // Keyed by id, not by array index: the list is a filtered view of what the
                // API returns, and an index key rebinds every checkbox below a removal.
                <div key={department.id}>
                    <label>
                        <input
                            type="checkbox"
                            checked={agentDepartments.indexOf(department.id) !== -1}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                onChange(
                                    e.target.checked
                                        ? [...agentDepartments, department.id]
                                        : agentDepartments.filter((id) => id !== department.id)
                                );
                            }}
                        />
                        <span>{department.name}</span>
                    </label>
                </div>
            ))}
        </>
    );
};
export default Departments;
